import * as types from '../actions/action-types';
import _ from 'lodash';

const stateFipsKey = 'sf';
const stateNameKey = 'sn';
const stateAbbrKey = 'sa';

const defaults = {
  loading: true,
  selected: {},
  list: [],
  data: [],
  dict: {},
};

/**
 * Set Selected state and create state level data (counties)
 *
 * @param store
 * @param stateFips
 */
function setState(store, stateFips) {
  const state = store.dict[+stateFips];
  const selected = _.assign({}, state, {
    name: state[stateNameKey],
    fips: state[stateFipsKey],
    abbr: state[stateAbbrKey]
  });

  return {
    ...store,
    selected
  };
}

/**
 * Create States list for selection controls
 *
 * @param data
 */
function getStateList(data) {
  return _.chain(data)
    .map(state => {
      return {
        name: state[stateNameKey],
        fips: state[stateFipsKey],
        abbr: state[stateAbbrKey]
      }
    })
    .filter(s => s.fips)
    .uniqBy('fips')
    .orderBy('name')
    .value();
}

/**
 * Set initial data and loading false
 *
 * @param store
 * @param data
 */
function setData(store, data) {
  return {
    ...store,
    loading: false,
    data: data,
    dict: _.keyBy(data, stateFipsKey),
    list: getStateList(data)
  };
}

export default (store = defaults, action) => {
  switch (action.type) {
    case types.SELECT_STATE:
      return setState(store, action.stateFips);
    case types.STATE_DATA_RECEIVED:
      return setData(store, action.data);
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/states-reducer.js